import { getQueryParamFromString } from 'v1/utils/urlHelpers';

const getElementByIdAs = <TDOMElement extends HTMLElement>(
  elementId: string,
): TDOMElement | null => {
  return document.getElementById(elementId) as TDOMElement | null;
};

const getQueryParamFromSrcScript = (param: string): string => {
  const scriptSrc = (document.currentScript as HTMLScriptElement)?.src;
  if (!scriptSrc) {
    throw new Error('Failed to get script src.');
  }

  const key = getQueryParamFromString(scriptSrc, param);
  if (!key) {
    throw new Error('Failed to get key from script src.');
  }

  return key;
};

export { getElementByIdAs, getQueryParamFromSrcScript };
